import { render } from "./AutomationListingEmptyStateNoResult.vue?vue&type=template&id=2348c137"
import script from "./AutomationListingEmptyStateNoResult.vue?vue&type=script&lang=js"
export * from "./AutomationListingEmptyStateNoResult.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__